import { ArrowLeft } from "lucide-react";
import { Button } from "../../ui/button";

/**
 * Jun-2026 (User-Wunsch · Msg 509) — „Zurück"-Button für alle Dispo-Modals.
 *
 * Rendert nur, wenn ein `onBack`-Handler übergeben wurde. Über `mr-auto` wird
 * der Button im `DialogFooter` linksbündig (abgesetzt von den Primär-Aktionen)
 * platziert. Der Klick löst nur die Navigation aus (kein Save → keine
 * versehentlichen Formular-Validierungsfehler).
 */
export function DispoBackButton({ onBack, className = "" }) {
    if (!onBack) return null;
    return (
        <Button
            type="button"
            variant="ghost"
            onClick={onBack}
            data-testid="dispo-modal-back"
            className={`text-gray-600 hover:text-gray-900 mr-auto ${className}`}
        >
            <ArrowLeft className="w-4 h-4 mr-1" /> Zurück
        </Button>
    );
}
